import { CustomAttributeReadProps } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import { getKindLikeValueSafely } from 'src/graphql/entities/custom-attributes/field-view-registry/utils';
import { YesNoPill } from './yes-no-pill';

export const CheckboxView = ({ value }: CustomAttributeReadProps) => {
  const checked = getKindLikeValueSafely(value, 'checkbox') === true;
  return <YesNoPill value={checked} />;
};
